import { FarmEffectData } from 'System/Farm/FarmEffectData';
import { DRAGONBONES_PATH } from './Dragonbones';

export const FARM_UNLOCK_LEVEL: number = 14;

export const FARM_EFFECT_DRAGONBONES_PATH = DRAGONBONES_PATH + '/Farm/Effects/';

export const FARM_ENVIRONMENT_EFFECTS: FarmEffectData[] = [
    {
        x: -250,
        y: 0,
        intervalRange: {
            min: 2500,
            max: 25000,
        },
        dragonbonesName: 'my_farm_effects',
        armatureName: "birds_1",
        animationNames: [
            'birds_1',
            'birds_2',
        ],
        yOffsetRange: [
            {
                min: -115,
                max: 155,
            },
            {
                min: -105,
                max: 123,
            },
        ],
    },
    {
        x: -13,
        y: 100,
        intervalRange: {
            min: 5000,
            max: 20000,
        },
        dragonbonesName: 'my_farm_effects',
        armatureName: 'leaves',
    },
    {
        x: 0,
        y: 0,
        intervalRange: {
            min: 31500,
            max: 76500,
        },
        dragonbonesName: 'my_farm_effects',
        armatureName: "clouds_1",
        animationNames: [
            'clouds_1',
            'clouds_2',
            'clouds_3',
            'clouds_4'
        ],
        yOffsetRange: [
            {
                min: -50,
                max: 95,
            },
            {
                min: -35,
                max: 55,
            },
            {
                min: -40,
                max: 115,
            },
            {
                min: -50,
                max: 105,
            },
        ],
    },
    {
        x: -574,
        y: 0,
        dragonbonesName: 'my_farm_effects',
        armatureName: 'rays',
    },
];
